require("prismjs/themes/prism-okaidia.css")
require("prismjs/plugins/line-numbers/prism-line-numbers.css")
require("./src/prism.css")

exports.onClientEntry = () => {};
